export const HISTORY_STATUS = ['PROCESSING', 'SUCCESSFUL', 'FAILED'];
export const STATUS_CLASSNAME = ['history--proecssing', 'history--successful', 'history--failed'];